import axios from 'axios';

const url = `${process.env.GATSBY_TWILL_URL}/sanctum/csrf-cookie`;

export async function getCsfr() {
  return axios.get(url);
}
